import UiLstStoreBase from '../../cls/stores/UiLstStoreBase'

/**
 * @class UiLstMeetingsStore
 * @extends UiLstStoreBase
 * @description This class represents the store for the UI list of meetings. It extends the UiLstStoreBase class and initializes the meetings store with default filters.
 */
class UiLstMeetingsStore extends UiLstStoreBase {
	/**
	 * @constructor
	 * @param {object} rootStore - The root store that holds the global state and other stores.
	 * @description Constructs an instance of UiLstMeetingsStore with the specified root store and initializes the store with default filters.
	 */
	constructor(rootStore) {
		// Call the parent constructor with the root store and default filters
		super(rootStore, {
			progress: 'pending, confirmed',
			show_all: false
		})
	}
}

export default UiLstMeetingsStore
